/**
 * The admin API returns user and profile flags in mixed shapes: MySQL tinyints (0/1),
 * booleans, or legacy strings such as 'active'. Treat only the clearly-on values as on.
 */
export function isFlagOn(value: unknown): boolean {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') return ['1', 'true', 'active'].includes(value.trim().toLowerCase());
  return false;
}
